const searchModal = document.querySelector('[data-header-search] .header__search__inner');
const closeSearch = searchModal?.querySelector('.voyado-search .close-container');

function closeVoyadoSearch() {
  document.querySelector('[data-header-search] details-modal')?.close?.();
}

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') closeVoyadoSearch();
});

closeSearch?.addEventListener('click', (event) => {
  // Only close when the visible close control is clicked — not the
  // transparent area of the full-width container, which overlaps the input.
  if (!event.target.closest('.close, .close-text')) return;
  closeVoyadoSearch();
});

// Backdrop click: close only when the click lands directly on one of the
// search overlay's background containers — not the input, cards, links or
// buttons inside it. (DetailsModal's own outside-click handler can't catch
// these because the overlay is fixed/full-screen and lives inside it.)
const BACKDROP_CLASSES = [
  'search-modal',
  'modal-overlay',
  'search-modal__content',
  'voyado-container',
  'voyado-results-container',
  'voyado-search',
];
searchModal?.addEventListener('click', (event) => {
  if (!BACKDROP_CLASSES.some((cls) => event.target.classList.contains(cls))) return;
  closeVoyadoSearch();
});

/* invalid card */
function isValidProductCard(html) {
  return (
    html.includes('prd-Card') &&
    !html.includes('template-404') &&
    !html.includes('Page Not Found') &&
    !html.includes('shopify-section-header') &&
    !html.includes('<title>404</title>')
  );
}

/* ORDERED PRODUCT RENDERING */
const renderedHandles = new Set();

function getProductInfo(linkHandle) {
  const productList = searchModal?.querySelector('.voyado-results__results--products');
  const link = `${window.location.origin}${linkHandle}?view=simple`;

  fetch(link)
    .then(res => {
      if (res.status === 404) return null;
      return res.text();
    })
    .then(html => {
      if (!html) return;
      if (!isValidProductCard(html)) return;
      if (html.includes('prd-Card_Title-soldOut')) return;

      const slot = productList.querySelector(`[data-handle="${linkHandle}"]`);
      if (!slot) return;

      slot.innerHTML = html;
      slot.classList.add('auto-Card');
    })
    .catch(() => { });
}

const v_search = searchModal?.querySelector('#voyado-search-input');
const suggestionsList = searchModal?.querySelector('.voyado-results__results');
const productList = searchModal?.querySelector('.voyado-results__results--products');
const viewAll = searchModal?.querySelectorAll('.prods__footer a') || [];

let cachedForYou = null;

function renderProducts(productGroups = []) {
  if (!productList) return;

  productList.innerHTML = '';
  renderedHandles.clear();

  const items = productGroups.slice(0, 4);

  items.forEach(group => {
    const product = group.products?.[0];
    if (!product) return;

    const handle = product.link;
    if (renderedHandles.has(handle)) return;

    renderedHandles.add(handle);

    const slot = document.createElement('div');
    slot.dataset.handle = handle;
    slot.dataset.ticket = product.ticket;

    productList.appendChild(slot);
  });

  items.forEach(group => {
    const product = group.products?.[0];
    if (!product) return;

    getProductInfo(product.link);
  });
}

function renderSuggestions(suggestions = []) {
  if (!suggestionsList) return;

  suggestionsList.innerHTML = '';

  suggestions.forEach((suggestion) => {
    const formatted = suggestion.highlighted
      .replace(/{/g, '<span>')
      .replace(/}/g, '</span>');

    const clean = suggestion.highlighted
      .replace(/{/g, '')
      .replace(/}/g, '');

    const item = document.createElement('div');
    item.className = 'voyado-results__suggestion-item';

    item.innerHTML = `
      <div class="result">
        <a href="/search?q=${clean}&origin=PHRASE_SUGGEST">${formatted}</a>
      </div>
    `;

    suggestionsList.appendChild(item);
  });

  suggestionsList.style.display = suggestions.length ? 'block' : 'none';
}

function showSearchState(query) {
  const resultsContainer = searchModal?.querySelector('.voyado-results-container');
  const resultsInit = searchModal?.querySelector('.results-container-init');
  const productsHeading = searchModal?.querySelector('.voyado-results--products h2');
  const onloadSuggestions = searchModal?.querySelector('.voyado-results__results--onload');

  if (resultsContainer) resultsContainer.style.display = 'grid';
  if (resultsInit) resultsInit.style.display = 'none';
  if (productList) productList.style.display = 'grid';
  if (productsHeading) productsHeading.textContent = 'Trending Results';
  if (onloadSuggestions) onloadSuggestions.classList.remove('active');

  viewAll.forEach((item) => {
    item.querySelector('.text').textContent = 'view all';
    item.href = `/search?q=${query}`;
  });
}

function showForYouState(type) {
  const resultsInit = searchModal?.querySelector('.results-container-init');
  const productsHeading = searchModal?.querySelector('.voyado-results--products h2');
  const productsCopy = searchModal?.querySelector('.voyado-results--products p');
  const onloadSuggestions = searchModal?.querySelector('.voyado-results__results--onload');

  if (resultsInit) resultsInit.style.display = 'grid';
  if (productList) productList.style.display = 'grid';
  if (productsHeading) {
    productsHeading.textContent = type === 'empty' ? 'Picked for you' : 'Trending Results';
  }
  if (productsCopy) {
    productsCopy.innerHTML = type === 'empty'
      ? ''
      : '<span class="none-found">No results could be found</span><span class="try-something">Refine your search or explore trending pieces below.</span>';
  }

  viewAll.forEach((item) => {
    item.querySelector('.text').textContent = 'Shop all';
    item.href = '/collections/all';
  });

  if (onloadSuggestions && type === 'empty') {
    onloadSuggestions.classList.add('active');
  }
}

async function getForYouResults() {
  if (cachedForYou) return cachedForYou;

  const res = await window.elevate.api.query.landingPage(
    { pageReference: '/', notify: window.elevate.predictedConsent },
    {
      recommendationLists: [
        { id: 'PERSONAL-1', algorithm: 'PERSONAL' },
      ],
    },
  );

  cachedForYou = res?.recommendationLists?.[0]?.productGroups || [];

  return cachedForYou;
}

/* MAIN SEARCH HANDLER */
v_search?.addEventListener('input', async (event) => {
  const query = event.target.value.trim();

  showForYouState('empty');

  try {
    // EMPTY QUERY → FOR YOU
    if (!query) {
      showForYouState('empty');
      const recs = await getForYouResults();
      renderProducts(recs);
      if (suggestionsList) suggestionsList.innerHTML = '';
      searchModal?.querySelector('.voyado-results__results--onload')?.classList.add('active');
      return;
    }

    const result = await window.elevate.api.query.autocomplete({ q: query, notify: window.elevate.trackingConsentGranted });

    const hasResults =
      result.phraseSuggestions.length > 0 &&
      result.totalHits !== 0;

    if (hasResults) {
      showSearchState(query);
      renderSuggestions(result.phraseSuggestions);
      renderProducts(result.productSuggestions);
      searchModal?.querySelector('.voyado-results__results--onload')?.classList.remove('active');
    } else {
      showForYouState('no-results');
      const recs = await getForYouResults();
      renderProducts(recs);
    }

  } catch (err) {
    console.warn('Error in search:', err);
  }
});

v_search?.addEventListener('keydown', event => {
  if (event.key === 'Enter') {
    event.preventDefault();
    const query = v_search.value.trim();
    if (!query) return;

    window.location.href = `/search?q=${encodeURIComponent(query)}`;
  }
});

document.addEventListener('DOMContentLoaded', async () => {
  try {
    if (!v_search || !productList) return;

    showForYouState('empty');
    const recs = await getForYouResults();
    renderProducts(recs);
  } catch (err) {
    console.warn('Error loading For You on page load:', err);
  }
});
